import i18n from "../i18n/config";

/**
 * Traduz payload { code, params } retornado pela API (namespace i18n `errors`).
 * @param {{ code?: string; params?: object }} errBody
 * @returns {string|null}
 */
export function translateApiPayload(errBody) {
  if (!errBody || typeof errBody !== "object") return null;
  const code = errBody.code;
  if (typeof code !== "string") return null;

  if (code.startsWith("billing.")) {
    const tail = code.slice("billing.".length);
    const keyMap = {
      limit_exceeded: "billingErrors.limitExceeded",
      limit_disabled: "billingErrors.limitDisabled",
      trial_requires_plan: "billingErrors.trialRequiresPlan",
      offer_not_actionable: "billingErrors.offerNotActionable",
    };
    const path = keyMap[tail] || "billingErrors.generic";
    const translated = i18n.t(path, { ns: "app" });
    if (!translated || translated === path) return null;
    return translated;
  }

  if (!code.startsWith("errors.")) return null;
  const subkey = code.slice("errors.".length);
  const params =
    errBody.params && typeof errBody.params === "object" ? { ...errBody.params } : {};
  const translated = i18n.t(subkey, { ns: "errors", ...params });
  if (!translated || translated === subkey) return null;
  return translated;
}
